import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { reduxForm, addArrayValue } from 'redux-form';
import userValidation from './userValidation';
import * as UserActions from 'redux/modules/users';
import { LinkContainer } from 'react-router-bootstrap';
import Select from 'react-select';
import { Button, Col, Row, Panel, Table, Alert } from 'react-bootstrap'

import _ from "underscore";
import { translate } from 'react-i18next';

@translate(['common'])

@connect(
  state => ({
    created: state.users.created,
    userCreatedError: state.users.userCreatedError,
    user: state.auth.user,
    groups: state.groups.data,
    loading: state.users.loading,
    fiches: state.fiches.data
  }),
  dispatch => bindActionCreators(UserActions, dispatch)
)
@reduxForm({
  form: 'createUserForm',
  fields: ['user.c_id', 'user.id',
    'user.nom', 'user.prenom', 'user.societe',
    'user.fonction', 'user.login',
    'user.password', 'user.telephone',
    'user.super_user', 'user.sites', 'group.groupList',
    'mail[].address',
    'mail[].panne_flag_debut',
    'mail[].panne_flag_fin',
    'mail[].panne_tempo',
    'mail[].usager_flag_debut',
    'mail[].usager_flag_fin',
    'mail[].usager_tempo',
    'mail[].dispo_flag_debut',
    'mail[].dispo_flag_fin',
    'mail[].dispo_tempo',
    'mail[].cyclique_tempo',
    'mail[].maintenance_tempo',
    'touched'

  ],
  validate: userValidation,
  destroyOnUnmount: true
}, undefined, {
  addValue: addArrayValue // mapDispatchToProps (will bind action creator to dispatch)
})

export default class CreateUserForm extends Component {


  shPass() {
    this.setState({ passVisible: !this.state.passVisible })
  }

  constructor(props) {
    super(props);
    this.state = {
      passVisible: false
    };

    this.shPass = this.shPass.bind(this);


  }


  componentWillUnmount() {
    this.props.dispatch(UserActions.clear())
  }

  componentDidMount() {
    this.props.fields.mail.addField()
  }

  render() {
    const {
      fields: { user, mail, group },
      formKey,
      handleSubmit,
      invalid,
      submitting,
      resetForm,
      createUser,
      values,
      userCreatedError,
      created,
      pristine,
      groups, initialValues, loading,
      user_info,t
    } = this.props;

    var mail_errors = 0
    _.each(mail, (m) => {
      if (m.address.invalid == true || m.address.value == '') {
        mail_errors++
      }
    })

    var canAddEmail = mail_errors == 0 && mail.length < 10

    const styles = require('containers/Users/AddUser.scss');

    if (userCreatedError == true) {
      var error = (
        <div className="alert alert-danger" role="alert">
          <span className="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span>
          {userCreatedError}
        </div>);
    } else {
      var error = '';
    }

    var cid = this.props.urlParams.id;
    var listUsersUrl = cid != undefined ? '/admin/users/' + cid : '/client/users';

    if (created == true) {
      var success = (
        <div className="alert alert-success col-xs-12 col-md-12" role="alert">
          <span className="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span>
          {" L'utilisateur a été crée"}
        </div>);
    } else {
      var success = '';
    }


    var pwd_glyph = this.state.passVisible ? <i onClick={() => this.shPass()} className="glyphicon glyphicon-eye-close" /> : <i className="glyphicon glyphicon-eye-open" onClick={() => this.shPass()} />
    var pass_type = this.state.passVisible ? 'text' : 'password'



    var pOptions = this.props.fiches.map((f) => {
      return { "label": <div>{f.products.map((p) => <div>{p.identification_NUM_ASC}</div>)}</div>, "value": f.id, clearableValue: (user_info.role != 'user' || user_info.super_user == 1), disabled: (user_info.role.indexOf('user') > -1 && user_info.super_user == 0) }
    })


    return (
      <form className="form-horizontal" autoComplete="new-password">

        <Col xs={12} md={6}>
          <div className="form-group">
            <div className={'col-xs-12 col-md-12' + (user.nom.touched && user.nom.error ? ' has-error' : '')}>
              <label className="col-xs-12 col-md-3 control-label">{t("main.lastname")} *</label>
              <div className={'col-xs-12' + ' col-md-' + (user.nom.touched && user.nom.error ? '5' : '8')}>
                <input type="text" className="col-xs-8 form-control" placeholder="" {...user.nom} />
              </div>
              {user.nom.touched && user.nom.error && <div className="col-xs-12 col-md-3 help-block">{user.nom.error}</div>}
            </div>
          </div>


          <div className="form-group">
            <div className={'col-xs-12 col-md-12' + (user.prenom.touched && user.prenom.error ? ' has-error' : '')}>
              <label className="col-xs-12 col-md-3 control-label">{t("main.firstname")} *</label>
              <div className={'col-xs-12' + ' col-md-' + (user.prenom.touched && user.prenom.error ? '5' : '8')}>
                <input type="text" className="col-xs-8 form-control" placeholder="" {...user.prenom} />
              </div>
              {user.prenom.touched && user.prenom.error && <div className="col-xs-12 col-md-3 help-block">{user.prenom.error}</div>}
            </div>
          </div>

          <div className="form-group">
            <div className={'col-xs-12 col-md-12' + (user.societe.touched && user.societe.error ? ' has-error' : '')}>
              <label className="col-xs-12 col-md-3 control-label">{t("main.society")} *</label>
              <div className={'col-xs-12' + ' col-md-' + (user.societe.touched && user.societe.error ? '5' : '8')}>
                <input type="text" className="col-xs-8 form-control" placeholder="" {...user.societe} />
              </div>
              {user.societe.touched && user.societe.error && <div className="col-xs-12 col-md-3 help-block">{user.societe.error}</div>}
            </div>
          </div>


          <div className="form-group">
            <div className={'col-xs-12 col-md-12' + (user.fonction.touched && user.fonction.error ? ' has-error' : '')}>
              <label className="col-xs-12 col-md-3 control-label">{t("userForm.fonction")}</label>
              <div className={'col-xs-12' + ' col-md-' + (user.fonction.touched && user.fonction.error ? '5' : '8')}>
                <input type="text" className="col-xs-8 form-control" placeholder="" {...user.fonction} />
              </div>
              {user.fonction.touched && user.fonction.error && <div className="col-xs-12 col-md-3 help-block">{user.fonction.error}</div>}
            </div>
          </div>

          <div className="form-group">
            <div className={'col-xs-12 col-md-12' + (user.login.touched && user.login.error ? ' has-error' : '')}>
              <label className="col-xs-12 col-md-3 control-label">Login *</label>

              <div className={'col-xs-12' + ' col-md-' + (user.login.invalid ? '8' : '8')}>
                <div className="input-group">
                  <input autoComplete="new-password" type="text" className="col-xs-8 form-control" placeholder="" {...user.login} />
                  <span className="input-group-addon">{'-' + this.props.c_id + '-usr'}</span>
                </div>
              </div>
              {user.login.touched && user.login.error && <div className="col-xs-12 col-md-3 help-block">{user.login.error}</div>}
            </div>
          </div>


          <div className="form-group">
            <div className={'col-xs-12 col-md-12' + (user.password.touched && user.password.invalid ? ' has-error' : '')}>
              <label className="col-xs-12 col-md-3 control-label">{t("main.password")}</label>


              <div className={'col-xs-12' + ' col-md-' + (user.password.invalid ? '8' : '8')}>
                <div className="input-group">
                  <input autoComplete="new-password" type={pass_type} className="form-control" placeholder="" {...user.password} />
                  <span className="input-group-addon">{pwd_glyph}</span>
                </div>
              </div>
              {user.password.touched && user.password.invalid && <div className="col-xs-12 col-md-3 help-block">{user.password.error}</div>}
            </div>
          </div>

          <div className="form-group">
            <div className={'col-xs-12 col-md-12' + (user.telephone.touched && user.telephone.error ? ' has-error' : '')}>
              <label className="col-xs-12 col-md-3 control-label">{t("main.phone")}</label>
              <div className={'col-xs-12' + ' col-md-' + (user.telephone.touched && user.telephone.error ? '5' : '8')}>
                <input type="text" className="col-xs-8 form-control" placeholder="" {...user.telephone} />
              </div>
              {user.telephone.touched && user.telephone.error && <div className="col-xs-12 col-md-3 help-block">{user.telephone.error}</div>}
            </div>
          </div>

          <div className="form-group">
            <div className={'col-xs-12 col-md-12' + (user.super_user.touched && user.super_user.error ? ' has-error' : '')}>
              <label className="col-xs-12 col-md-3 control-label">{t("main.super_user")}</label>
              <div className={'col-xs-12' + ' col-md-' + (user.super_user.touched && user.super_user.error ? '5' : '8')}>
                <input type="checkbox" className="" placeholder="" {...user.super_user} onChange={(e) => {


                  user.super_user.onChange(!user.super_user.value)


                  //On selectionne tous les groupes pour le SUPER USER
                  /*if (user.super_user.value) {
                    var ng = []
                  } else {
                    var ng = groups.map((g) => {
                      return g.id;
                    })
                  }

                  group.groupList.onChange(ng)*/


                }} />				      </div>
              {user.super_user.touched && user.super_user.error && <div className="col-xs-12 col-md-3 help-block">{user.super_user.error}</div>}
            </div>



          </div>



          <div className="form-group" >
            <div className={'col-xs-12 col-md-12' + (user.sites.touched && user.sites.error ? ' has-error' : '')}>
              <label className="col-xs-12 col-md-3 control-label">{t("userForm.associated_products")}</label>
              <div className={'col-xs-12' + ' col-md-' + (user.sites.touched && user.sites.error ? '5' : '8')} >
                <Select style={{ zIndex: 100000 }}
                  allowCreate={false}
                  clearable={(user.role != 'user' || user.super_user == 1)}
                  name="form-field-name"
                  options={pOptions}
                  multi={true}
                  {...user.sites}
                  onBlur={() => user.sites.onBlur()}
                />
                <div style={{ marginTop: '5px' }}>
                  <Button bsSize="xs" bsStyle="success" onClick={() => user.sites.onChange(pOptions.filter(o => !o.disabled).map(o => o.value))}>
                    <i className="fa fa-check-square-o" /> {t("main.select_all")}
                  </Button>
                  {' '}
                  <Button bsSize="xs" bsStyle="danger" onClick={() => user.sites.onChange([])}>
                    <i className="fa fa-square-o" /> {t("main.deselect_all")}
                  </Button>
                </div>
              </div>
            </div>
          </div>



          <div className="form-group">
            <div className={'col-xs-12 col-md-12' + (group.groupList.touched && group.groupList.error ? ' has-error' : '')}>
              <label className="col-xs-12 col-md-3 control-label">{t("main.groups")}</label>
              <div className={'col-xs-12' + ' col-md-' + (group.groupList.touched && group.groupList.error ? '5' : '8')}>

                <Select
                  name="groupList"
                  options={groups.map((g) => { return { "label": g.name, "value": g.id } })}
                  multi={true}
                  allowCreate={false}
                  {...group.groupList}
                  onBlur={() => group.groupList.onBlur(group.groupList.value)}
                />
                <div style={{ marginTop: '5px' }}>
                  <Button bsSize="xs" bsStyle="success" onClick={() => group.groupList.onChange(groups.map(g => g.id))}>
                    <i className="fa fa-check-square-o" /> {t("main.select_all")}
                  </Button>
                  {' '}
                  <Button bsSize="xs" bsStyle="danger" onClick={() => group.groupList.onChange([])}>
                    <i className="fa fa-square-o" /> {t("main.deselect_all")}
                  </Button>
                </div>
              </div>
            </div>

          </div>
          

          <br/><br/>

          <div className="form-group">

            <div className="col-xs-offset-0 col-xs-10">

              <button type="button" className="btn btn-success"
                onClick={handleSubmit(() => {

					        /*try {
					        	values.group.groupList = values.group.groupList.map((g)=>{return g.value})
					        } catch(e){
					        	
					        }*/

                  if (values.mail.length < 1) {
                    alert('Vous devez ajouter au minimum un email.')
                    return
                  }



                  createUser(values, this.props.urlParams)
                    .then(result => {
                      if (result && typeof result.error === 'object') {
                        return Promise.reject(result.error);
                      }
                    })
                })}
                disabled={pristine || invalid || submitting}>
                <i className={'fa ' + (loading ? 'fa-cog fa-spin' : 'fa-cloud')} />&nbsp;
                
                {t("main.create_the_user")}
					  </button>
              &nbsp;
					  <LinkContainer to={listUsersUrl}>
                <button className="btn btn-primary" type="button">
                  {t("userForm.back_to_user_list")}
						  </button>
              </LinkContainer>
              <br />
              <br />
              <div className="col-xs-12 col-sm-6">
                {error}
                {success}
              </div>
            </div>

          </div>

        </Col>


        <Col xs={12} md={6}>

          <div className="col-xs-12">

            <div className="form-group">
              <fieldset>
                    <legend>{t("main.emails")} <span style={{ color: 'red', fontSize: '14px' }}>({t("userForm.email_required")})</span></legend>
                    {mail.map((email, emailIndex) => <div key={emailIndex}>
                      <div className="col-xs-12 col-md-12">
                        <Alert bsStyle='danger'>
                          <i className="fa fa-info-circle" /> &nbsp;
                          {t("userForm.email_alert_desc")}
                          
                        </Alert>
                      </div>
          
                    <div className="form-group">
                    <div className={'col-xs-12 col-md-12' + (email.address.touched && email.address.error ? ' has-error' : '')}>
                      <label className="col-xs-12 col-md-2 control-label">Email {emailIndex+1} {emailIndex === 0 && <span style={{ color: 'red' }}>*</span>}</label>
                          
                      <div className={'col-xs-12'+ ' col-md-' + (user.password.invalid ? '5' : '8')}>

                      <div className={emailIndex > 0 ? "input-group" : ''}> 

                        <input autoComplete="new-password7455" type="text" className="form-control" placeholder="" {...email.address}/> 
                          {emailIndex > 0 && 
                            <span style={{'cursor':'pointer'}} className="input-group-addon"> <i className="fa fa-times text-danger" onClick={() => {
                              mail.removeField(emailIndex)
                              
                              this.props.fields.touched.onChange(true);
                              }}></i>
                            </span>
                          }
                          </div>
                        </div>

                          
                        <br/><br/>
                            

                        <div className="col-md-12 col-xs-12">
                          <Panel collapsible defaultExpanded={true} expanded={true}  header={t("main.events")} onClick={()=>this.setState({expanded:!this.state.expanded})}>
                            <div className="table-responsive">
                              <Table striped bordered hover> 
                                <thead>
                                  <tr> 
                                  <th style={{ verticalAlign:"middle"}}><div style={{width:"93px"}}>{t("main.events")}			</div></th>
                                  <th style={{ verticalAlign:"middle"}}><div style={{width:"105px"}}>{t("userForm.start_alert")}</div></th> 
                                  <th style={{ verticalAlign:"middle"}}><div style={{width:"82px"}}>{t("userForm.end_alert")}	</div></th>
                                  <th style={{ verticalAlign:"middle"}}><div style={{width:"127px"}}>{t("userForm.tempo_alert")}</div></th>
                                  </tr>									
                                </thead>

                                <tbody>
                                  <tr>
                                    <td>{t("userForm.panne_appareil")}</td>
                                    <td>
                                      <input type="checkbox" className="" placeholder="" {...email.panne_flag_debut}/>
                                    </td>
                                    
                                    <td>
                                      <input type="checkbox" className="" placeholder="" {...email.panne_flag_fin} />
                                    </td>
                                    
                                    <td>
                                      <input style={{width:'50px', display:'inline'}} className="" type="number" {...email.panne_tempo} min="0" />
                                      &nbsp;{t("userForm.days")}
                                    </td>
                                  
                                  </tr>
                                  
                                  
                                  <tr> 
                                    <td>{t("userForm.usager_bloque")}</td>
                                    <td>
                                      <input type="checkbox" className="" placeholder="" {...email.usager_flag_debut} />
                                    </td>
                                    
                                    <td>
                                      <input type="checkbox" className="" placeholder="" {...email.usager_flag_fin}/>
                                    </td>
                                    
                                    <td>
                                      <input style={{width:'50px'}} type="number" {...email.usager_tempo} min="0"/>&nbsp;
                                      {t("userForm.hours")}
                                    </td>
                                  </tr>    				                      
                                  
                                  <tr>
                                    <td>{t("userForm.sts_indispo")}</td>
                                    <td>
                                      <input type="checkbox" className="" placeholder="" {...email.dispo_flag_debut} /> 
                                    </td>
                                    
                                    <td>
                                      <input type="checkbox" className="" placeholder="" {...email.dispo_flag_fin} />   
                                    </td>
                                    
                                    <td>
                                      <input style={{width:'50px'}} type="number" {...email.dispo_tempo} min="0"/>&nbsp;{t("userForm.days")}
                                    </td>
                                  </tr>
                                  
                                  <tr>
                                <td colSpan={4}>                                    
                                  {t("userForm.absence")} <input style={{width:'50px'}} type="number" {...email.maintenance_tempo} min="0"/> 
                                  &nbsp;{t("userForm.weeks")}
                                </td>
                              </tr> 
                                  
                                  
                              <tr>
                                <td colSpan={4}>    				                        
                                  {t("userForm.defaut_test")} &nbsp; <input type="checkbox" className="" placeholder="" {...email.cyclique_tempo} />    				                        
                                </td>
                              </tr> 

                            </tbody> 
                          </Table>
                        </div>
                      </Panel> 
            
                    </div>
                    {email.address.touched && email.address.error && <div className="col-xs-4 help-block">{email.address.error}</div>}
                  </div>
                </div>
              </div>
            )}
                  
            <div className={'form-group col-xs-12 col-md-12'}  style={{marginLeft:'0px'}} >			  			
                      
              <Button disabled={!canAddEmail} bsStyle='info' type="button" onClick={() => {
                if(canAddEmail) { 
                  mail.addField({contact_alert:false}) 
                }    						    	 
              }}><i/> {t("userForm.add_email")}
              </Button>    			              		          
            </div>
              
              
          </fieldset>

            </div>




          </div>

        </Col>

      </form>
    );
  }
}

